var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWrenchIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    clipPath: "url(#clip0_18351_4949)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.2425 7.94908L16.881 6.31063C17.3935 5.79813 18.253 5.99692 18.3136 6.71918C18.3266 6.87343 18.3332 7.02949 18.3332 7.18709C18.3332 10.2359 15.8616 12.7075 12.8127 12.7075C12.1202 12.7075 11.4574 12.58 10.8466 12.3471L5.52176 17.6719C4.63982 18.5538 3.2099 18.5538 2.32796 17.6719C1.44602 16.7899 1.44602 15.36 2.32796 14.4781L7.65275 9.15331C7.41986 8.5425 7.29232 7.87969 7.29232 7.18709C7.29232 4.13825 9.7639 1.66667 12.8127 1.66667C12.9694 1.66667 13.1246 1.6732 13.278 1.686C14.0004 1.74628 14.1994 2.60596 13.6868 3.11858L12.0494 4.75598L12.5779 7.42065L15.2425 7.94908Z",
    stroke: "#181C32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18351_4949"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrenchIcon);
export default __webpack_public_path__ + "static/media/wrench-icon.07f8dd748cfc7aa1f210a124cab1542f.svg";
export { ForwardRef as ReactComponent };